import type { FunctionArgs, FunctionReturnType } from "convex/server";
import type { api } from "@constructionautomation/backend";
import type { Id } from "@constructionautomation/backend/convex/_generated/dataModel";
import type { StatusKey } from "@/components/status-badge";

export type AiCountPage = FunctionReturnType<typeof api.takeoffPilot.jobs.listAiCountPage>;
export type AiBatchReview = Omit<FunctionArgs<typeof api.takeoffPilot.aiReviewActions.review>, "jobId" | "lineageSessionId">;
export type AiLatestReview = NonNullable<FunctionReturnType<typeof api.takeoffPilot.aiReviewActions.latest>>;
export type AiMeasurementBasis = NonNullable<AiCountPage["runs"][number]["measurementBasis"]>;
export type AiCountTag = {
  tagId: Id<"takeoffPilotExtractedTags">;
  rawValue: string;
  colorHex?: string;
  isCustom?: boolean;
};

export const AI_REVIEW_STATUS: Record<AiCountPage["proposals"][number]["reviewStatus"], { status: StatusKey; label: string }> = {
  pending_review: { status: "pending", label: "Needs Review" },
  accepted: { status: "completed", label: "Accepted" },
  rejected: { status: "error", label: "Rejected" },
};
